import React from 'react';
import propTypes from 'prop-types';
import { Dropdown } from '@tcc/crate';
import { getMessage } from 'util/locale';
import { CropProtectionDropdown } from './CropProtectionDropdown';
import {
  protectionApplicationTypes} from '../../constants/activities';
import { toLower, first } from 'lodash';

export const ChemicalTypeSelector = ({
  chemicalTypeIds,
  getProducts,
  isEditRoute,
  allProducts,
  onCreateChemical,
  isFieldOwnerValue,
  selectedProduct,
  selectedProtectionId,
  onAddProduct,
  selectedProtection,
  selectedProducts,
  onSelectProtection,
  inputsClassString,
  activityType
}) => {
  const isEditTankMix = activityType === protectionApplicationTypes.APPLICATION_MIX && isEditRoute;
  const splitIndex = activityType.indexOf('-');
  const applicationType = activityType.substring(splitIndex + 1, activityType.length);
  const type = `application-${toLower(selectedProtectionId)}`;
  const products = getProducts((isEditTankMix || !isEditRoute ) ? type : activityType);

  const cropProtectionDropdown = (applicationProducts) => {
    const selectedApplication = (!isEditTankMix && applicationProducts) 
      ? applicationProducts.find(x => x.id === first(selectedProduct)) : null;
    return selectedProtectionId && (
      <CropProtectionDropdown
        allProducts={allProducts}
        chemicalTypeIds={chemicalTypeIds}
        createCustomChemical={onCreateChemical}
        disabled={selectedProtectionId === selectedProtection && isEditTankMix}
        dropdownLabel={getMessage('label-text__product')}
        isEditRoute={isEditRoute}
        isFieldOwner={isFieldOwnerValue}
        onSetValue={(productId) => onAddProduct(productId)}
        products={applicationProducts}
        selectedProduct={selectedApplication}
        substanceTypeUuid={selectedProtectionId} />
    );
  };
  const chemTypeSelectionsV2 = (
    <section className="crop-protection-inputs-container">
      <Dropdown
        disabled={selectedProducts.length >= 8 || (!isEditTankMix && isEditRoute)}
        label={getMessage('crop-application')}
        options={Object.keys(chemicalTypeIds).map(chemType => getMessage(`label-text__product-${chemType}`))}
        placeholder={isEditTankMix
          ? getMessage('placeholder-text__select-fertilizer-type')
          : getMessage(`label-text__product-${applicationType}`) }
        setValue={onSelectProtection}
        value={selectedProtection} />
      <div className={inputsClassString}>
        <div className={`crop-protection-radio ${!isEditRoute ? 'crop-protection-hidden' : ''}`}>
          {getMessage(`label-text__product-${selectedProtection}`)}
        </div>
        {cropProtectionDropdown(products)}
      </div>
      <div className='crop-protection-error'>
        {selectedProducts.length >= 8 && getMessage('crop-protection-tank-mix-max-products')}
      </div>
    </section>
  );

  ChemicalTypeSelector.propTypes = {
    chemicalTypeIds: propTypes.array,
    getProducts: propTypes.func,
    isEditRoute :  propTypes.bool,
    allProducts :  propTypes.object,
    onCreateChemical :  propTypes.func,
    isFieldOwnerValue :  propTypes.bool,
    selectedProduct :  propTypes.func,
    selectedProtectionId :  propTypes.func,
    onAddProduct :  propTypes.func,
    selectedProtection :  propTypes.object,
    selectedProducts :  propTypes.array,
    onSelectProtection :  propTypes.func,
    inputsClassString :  propTypes.string,
    activityType :  propTypes.string,
    onSetValueV :  propTypes.func,
  };

  return chemTypeSelectionsV2;
};
